import { dew as _constantsDew } from "../constants";
import { dew as _patternDew } from "../../../utils/pattern";
import { dew as _AbstractParserWithWordBoundaryDew } from "../../../common/parsers/AbstractParserWithWordBoundary";
import { dew as _weekdaysDew } from "../../../common/calculation/weekdays";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  const constants_1 = _constantsDew();
  const pattern_1 = _patternDew();
  const AbstractParserWithWordBoundary_1 = _AbstractParserWithWordBoundaryDew();
  const weekdays_1 = _weekdaysDew();
  const PATTERN = new RegExp(`(?:(?:,|\\(|（)\\s*)?` + `(?:в\\s*?)?` + `(?:(эту|этот|прошлый|прошлую|следующий|следующую|следующего)\\s*)?` + `(${pattern_1.matchAnyPattern(constants_1.WEEKDAY_DICTIONARY)})` + `(?:\\s*(?:,|\\)|）))?` + `(?:\\s*на\\s*(этой|прошлой|следующей)\\s*неделе)?` + `${constants_1.REGEX_PARTS.rightBoundary}`, constants_1.REGEX_PARTS.flags);
  const PREFIX_GROUP = 1;
  const WEEKDAY_GROUP = 2;
  const POSTFIX_GROUP = 3;
  class RUWeekdayParser extends AbstractParserWithWordBoundary_1.AbstractParserWithWordBoundaryChecking {
    innerPattern() {
      return PATTERN;
    }
    patternLeftBoundary() {
      return constants_1.REGEX_PARTS.leftBoundary;
    }
    innerExtract(context, match) {
      const dayOfWeek = match[WEEKDAY_GROUP].toLowerCase();
      const weekday = constants_1.WEEKDAY_DICTIONARY[dayOfWeek];
      const prefix = match[PREFIX_GROUP];
      const postfix = match[POSTFIX_GROUP];
      let modifierWord = prefix || postfix;
      modifierWord = modifierWord || "";
      modifierWord = modifierWord.toLowerCase();
      let modifier = null;
      if (modifierWord == "\u043F\u0440\u043E\u0448\u043B\u044B\u0439" || modifierWord == "\u043F\u0440\u043E\u0448\u043B\u0443\u044E" || modifierWord == "\u043F\u0440\u043E\u0448\u043B\u043E\u0439") {
        modifier = "last";
      } else if (modifierWord == "\u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439" || modifierWord == "\u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E" || modifierWord == "\u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0439" || modifierWord == "\u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0433\u043E") {
        modifier = "next";
      } else if (modifierWord == "\u044D\u0442\u043E\u0442" || modifierWord == "\u044D\u0442\u0443" || modifierWord == "\u044D\u0442\u043E\u0439") {
        modifier = "this";
      }
      return weekdays_1.createParsingComponentsAtWeekday(context.reference, weekday, modifier);
    }
  }
  exports.default = RUWeekdayParser;
  //# sourceMappingURL=RUWeekdayParser.js.map
  return exports;
}